








































































import tickets from '@/store/types/tickets';
import { TicketParams } from '@/store/interfaces/tickets';
import detailModal from '@/components/tickets/modals/detail.vue';
import updateModal from '@/components/tickets/modals/update.vue';
import root from '@/store/types/root';
import { TeipNotifications } from '@/util/teipNotifications';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import DatesFormat from '@/util/classes/datesFormat';
import { ticketableType } from '@/util/transformString/translationsDecorator';
import StatusBadges from '@/components/Reusable/statusBadges.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Vue from 'vue';

const date = new DatesFormat();

export default Vue.extend({
  name: 'Tickets',
  components: {
    detailModal,
    updateModal,
    StatusBadges,
  },
  data: () => ({
    searchQueryProp: '',
    showModal: false,
    success: false,
    showModalUpdate: false,
    rowselect: {},
    propsToSearch: [] as tPropsToSearch,
    showModalDetail: false,
    tableColumns: [
      {
        prop: 'user.email',
        label: 'Email',
        minWidth: 250,
        sortable: true,
      },
      {
        prop: 'status',
        label: 'Estado',
        minWidth: 170,
        sortable: true,
        slotName: 'status',
      },
      {
        prop: 'ticketable_type',
        label: 'Tipo de ticket',
        minWidth: 200,
        sortable: true,
        formatter: (row: TicketParams): string => {
          return ticketableType(row.ticketable_type);
        },
      },
      {
        prop: 'created_at',
        label: 'Registrada',
        minWidth: 200,
        sortable: true,
        formatter: (row: TicketParams): string => {
          return date.formatDateTime(row.created_at);
        },
      },
      {
        prop: 'updated_at',
        label: 'Último movimiento',
        minWidth: 200,
        sortable: true,
        formatter: (row: TicketParams): string => {
          return date.formatDateTime(row.updated_at);
        },
      }
    ] as tTableColumns,
  }),
  computed: {
    ...mapGetters({
      getProccess: root.getters.GET_START_PROCESS,
      getTicketList: `ticketsModule/${tickets.getters.GET_TICKET_LIST}`,
    }),
  },
  destroyed() {
    this.cleanFilter();
  },
  methods: {
    ...mapActions({
      updateStatusTicket: `ticketsModule/${tickets.actions.UPDATE_STATUS_TICKET}`,
      ticketList: `ticketsModule/${tickets.actions.TICKET_LIST}`,
    }),
    ...mapMutations({
      cleanFilter: `ticketsModule/${tickets.mutations.SET_CLEAN_FILTER}`,
      cleanFilterMutation: `ticketsModule/${tickets.mutations.SET_CLEAN_FILTER}`,
    }),
    ticketSelected(ticket: TicketParams) {
      this.$data.rowselect = ticket;
    },
    detailTicket() {
      this.$data.showModalDetail = true;
    },
    updateTicket() {
      this.$data.showModalUpdate = true;
    },
    updateStatus(status: string) {
      const dataToSend = {
        id: this.$data.rowselect.id,
        data: {
          status,
        },
      };
      const notification = new TeipNotifications();
      this.updateStatusTicket(dataToSend)
        .then(() => {
          this.success = true;
          notification.success('Status cambiado satisfactoriamente :)');
        })
        .catch(() => {
          notification.warning('Algo ha salido mal :(');
        })
        .finally(() => {
          this.success = false;
        });
    },
    getTicketWithQuery(query: string) {
      this.searchQueryProp = query ? `&${query}` : '';
    },
  },
});
